{
  "Billing": "Cobrança",
  "Return to App": "Voltar ao aplicativo",
  "Home": "Início",
  "Calendar": "Calendário",
  "Dashboard": "Painel",
  "ATP": "ATP",
  "Subscriptions": "Assinaturas",
  "Payment Methods": "Métodos de pagamento",
  "Purchases": "Compras",
  "View Profile": "Ver perfil",
  "TrainingPeaks Athlete Since": "Atleta TrainingPeaks desde",
  "TrainingPeaks Coach Since": "Treinador TrainingPeaks desde",
  "Invoice": "Fatura",
  "No results": "Nenhum resultado",
  "qtr": "trim.",
  "Show all transactions": "Mostrar todas as transações",
  "No transactions found": "Nenhuma transação encontrada",
  "Loading purchases": "Carregando compras",
  "Error loading purchases": "Erro ao carregar compras",
  "Active": "Ativa",
  "Inactive": "Inativa",
  "Cancelled": "Cancelada",
  "PastDue": "Vencida",
  "Trialing": "Em teste",
  "Next Renewal": "Próxima renovação",
  "Manage": "Gerenciar",
  "plus tax": "mais impostos",
  "No subscriptions found": "Nenhuma assinatura encontrada",
  "No purchases found": "Nenhuma compra encontrada",
  "Show all": "Mostrar tudo",
  "Show less": "Mostrar menos",
  "Date": "Data",
  "Description": "Descrição",
  "Amount": "Valor",
  "Status": "Status",
  "Paid": "Paga",
  "Failed": "Falhou",
  "Pending": "Pendente",
  "Refunded": "Reembolsada",
  "Loading": "Carregando",
  "Error loading data": "Erro ao carregar dados",
  "month": "mês",
  "year": "ano",
  "quarter": "trimestre",
  "mo": "mês",
  "yr": "ano",
  "Default": "Padrão",
  "Expires": "Expira",
  "Card ending in": "Cartão terminado em",
  "Flexible planning to fit your life": "Planejamento flexível para a sua vida",
  "Actionable Insights to keep you on track": "Insights práticos para manter você no caminho",
  "Strength training to avoid injury": "Treino de força para evitar lesões",
  "Ride the world inside on Virtual": "Pedale pelo mundo em ambientes internos com o Virtual",
  "Any sport, any device, any time": "Qualquer esporte, qualquer dispositivo, a qualquer hora",
  "Annual": "Anual",
  "Monthly": "Mensal",
  "Billed USD $134.99/yr": "Cobrado USD 134,99/ano",
  "Most Popular": "Mais popular",
  "$19.95 $11.25/mo": "$19,95 $11,25/mês",
  "$19.95/mo": "$19,95/mês",
  "Checkout": "Finalizar compra",
  "Progress starts with Premium.": "O progresso começa com o Premium.",
  "Add Card": "Adicionar cartão",
  "Close": "Fechar",
  "Primary": "Principal",
  "Delete": "Excluir",
  "Make Primary": "Definir como principal",
  "Error loading payment methods": "Erro ao carregar métodos de pagamento",
  "Your card has expired. Please add a new card.": "Seu cartão expirou. Adicione um novo cartão.",
  "Unable to load payment form. Please try again later.": "Não foi possível carregar o formulário de pagamento. Tente novamente mais tarde.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "Uma cobrança temporária de USD 1,00 será feita para validar seu método de pagamento. Essa cobrança será reembolsada automaticamente.",
  "Payment method added successfully": "Método de pagamento adicionado com sucesso",
  "Default payment method updated": "Método de pagamento padrão atualizado",
  "Payment method deleted": "Método de pagamento excluído",
  "Failed to set default payment method": "Não foi possível definir o método de pagamento padrão",
  "Failed to update default payment method": "Não foi possível atualizar o método de pagamento padrão",
  "Failed to delete payment method": "Não foi possível excluir o método de pagamento",
  "Maximize Your Premium Subscription \n Before You Go!": "Aproveite ao máximo sua assinatura Premium\nantes de sair!",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Pedale em ambientes internos com nossa experiência de ciclismo virtual",
  "Strength Builder": "Criador de treinos de força",
  "Create and save strength workouts": "Crie e salve treinos de força",
  "Metrics Charts": "Gráficos de métricas",
  "Analyze metrics from your synced devices": "Analise métricas dos seus dispositivos sincronizados",
  "Performance Metrics": "Métricas de desempenho",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Condicionamento (CTL), fadiga (ATL) e forma (TSB)",
  "Peak Performances": "Melhores desempenhos",
  "Track and compare your best efforts": "Acompanhe e compare seus melhores esforços",
  "NEW!": "NOVO!",
  "Cancel Subscription": "Cancelar assinatura",
  "Renew Subscription": "Renovar assinatura",
  "Complimentary": "Cortesia",
  "Your complimentary access is active through": "Seu acesso de cortesia está ativo até",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Mantenha suas metas em vista: renove o Premium para continuar no caminho certo até o dia da prova.",
  "Renew": "Renovar",
  "Auto-Renew Off": "Renovação automática desativada",
  "Access through": "Acesso até",
  "Turn Auto-Renew On": "Ativar renovação automática",
  "Are you sure you want to cancel coaching?": "Tem certeza de que deseja cancelar o coaching?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Alcançar suas metas exige o acompanhamento certo. Antes de cancelar, informe-nos se você precisa pausar, ajustar o nível do seu pacote ou falar diretamente com um especialista do Coach Match.",
  "Pause, Adjust, or Contact Support": "Pausar, ajustar ou falar com o suporte",
  "Yes, Cancel": "Sim, cancelar",
  "Keep My Coaching": "Manter meu coaching",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Assinatura Coach Match: Pausar, ajustar ou falar com um especialista",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Olá equipe Coach Match,\n\nEntro em contato sobre minha assinatura de coaching. Antes de decidir se vou cancelar, gostaria de [pausar minha assinatura / ajustar o nível do meu pacote / falar com um especialista do Coach Match].\n\nMeu e-mail de conta é: [Seu e-mail]\n\nObrigado(a)!",
  "Before you go...": "Antes de ir...",
  "What's the reason for canceling?": "Qual é o motivo do cancelamento?",
  "Price / Financial Reasons": "Preço / Motivos financeiros",
  "The subscription cost no longer fits my budget.": "O custo da assinatura não cabe mais no meu orçamento.",
  "Injured / Health Reasons": "Lesão / Motivos de saúde",
  "I'm unable to train due to injury or health.": "Não consigo treinar devido a lesão ou saúde.",
  "Finished Goal Event": "Evento objetivo concluído",
  "I completed my target race or event.": "Completei minha corrida ou evento alvo.",
  "Poor Experience / Fit": "Experiência ruim / Não se encaixou",
  "The coaching style or program wasn't the right match.": "O estilo de coaching ou o programa não era o mais adequado.",
  "Temporary Pause / Restart Later": "Pausa temporária / Retomar mais tarde",
  "Life got busy — I'd like to come back when I'm ready.": "A vida ficou corrida — gostaria de voltar quando estiver pronto(a).",
  "Other": "Outro",
  "Optional: Why?": "Opcional: Por quê?",
  "Continue": "Continuar",
  "Keep Subscription": "Manter assinatura"
}
